export enum CurrencyCode {
  PLN = 'PLN',
  EUR = 'EUR',
  USD = 'USD',
}
